module.exports = __webpack_public_path__ + "assets/img/tri-force-news-active.55445362.svg";